import "./HairMedicine.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import MedicinaCapilarDeAltoNivel from "./sections/MedicinaCapilarDeAltoNivel";
import SolucionesDeRecuperaciN from "./sections/SolucionesDeRecuperaciN";
import ConsultaDeValoraciNMDica from "./sections/ConsultaDeValoraciNMDica";
import ClinicalTreatments from "./sections/ClinicalTreatments";
import HairImprovementTimeline from "./sections/HairImprovementTimeline";
import HairTreatments from "./sections/HairTreatments";
import PieDePGinaInstitucional from "@/reusable_sections/Footer";
export default function HairMedicinePage() {
  return <div>
      <NavegaciNPrincipal />
      <MedicinaCapilarDeAltoNivel />
      <SolucionesDeRecuperaciN />
      <ConsultaDeValoraciNMDica />
      <ClinicalTreatments />
      <HairImprovementTimeline />
      <HairTreatments />
      <PieDePGinaInstitucional />
    </div>;
}